/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ServiceLocation
 */
export interface ServiceLocation {
    /**
     * 
     */
    type: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    phone?: string;
    /**
     * 
     */
    street: string;
    /**
     * 
     */
    zip_code: string;
    /**
     * 
     */
    city: string;
    /**
     * 
     */
    state: string;
    /**
     * 
     */
    county: string;
}

/**
 * Check if a given object implements the ServiceLocation interface.
 */
export function instanceOfServiceLocation(value: object): value is ServiceLocation {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('zip_code' in value) || value['zip_code'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('county' in value) || value['county'] === undefined) return false;
    return true;
}

export function ServiceLocationFromJSON(json: any): ServiceLocation {
    return ServiceLocationFromJSONTyped(json, false);
}

export function ServiceLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServiceLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'name': json['name'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'street': json['street'],
        'zip_code': json['zip_code'],
        'city': json['city'],
        'state': json['state'],
        'county': json['county'],
    };
}

export function ServiceLocationToJSON(json: any): ServiceLocation {
    return ServiceLocationToJSONTyped(json, false);
}

export function ServiceLocationToJSONTyped(value?: ServiceLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'name': value['name'],
        'phone': value['phone'],
        'street': value['street'],
        'zip_code': value['zip_code'],
        'city': value['city'],
        'state': value['state'],
        'county': value['county'],
    };
}

